import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getUnidadesConCitas.php';

export default function getUnidadesConCitas({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}